import { FC } from "react";
import { MarketSizeBySpend } from "./MarketSizeBySpend";
import { VIEW_OPTION_NAME } from "../constants";
import { useWorkspaceStore } from "../../../store/workspace/WorkspaceStore";
import { WorkspaceHeader } from "../../../components/WorkspaceHeader";

export const Header: FC = () => {
  const selectedView = useWorkspaceStore((state) => state.selectedView);

  return (
    <WorkspaceHeader
      title={VIEW_OPTION_NAME[selectedView]}
      subheader={<MarketSizeBySpend />}
    />
  );
};
